module.exports = __webpack_public_path__ + "static/kraft-heinz.a5c17739.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/kraft-heinz.svg
// module id = 421
// module chunks = 59819425949494